<template>
  <div class="listview">
    <div class="listview__listing">
      <table>
        <thead class="none">
          <tr>
            <td class="listview__title fullname">FULL NAME</td>
            <td class="listview__title email">EMAIL</td>
            <td class="listview__title date">DATE</td>
            <td class="listview__title code">VOUCHER CODE</td>
            <td class="listview__title price">PRICE</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in items" :key="index" class="content">
            <td class="fullname">
              <span>
                <b>{{item.fullname}}</b>
              </span>
            </td>
            <td class="email">
              <span>
                {{item.email}}
              </span>
            </td>
            <td class="date">
              <span>
                {{formatDate(item.date)}}
              </span>
            </td>
            <td class="code">
              <span>
                {{item.code}}
              </span>
            </td>
            <td class="price">
              <span>
                {{item.price | formatMoney}}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="listview__showmore">
        <slot name="infiniteLoading"/>
      </div>
      <div class="emptyState">
        <adx-empty-selection v-if="isEmpty && !loading" />
      </div>
      <div class="listview__loadingWrapper">
        <slot name="loading" />
      </div>
    </div>
  </div>
</template>

<script>
import Toggle from '@/components/Toggle'
import DropdownSort from '@/components/Form/SelectDropdown'
import { formatShortDate } from '@/lib/util'

export default {
  name: 'adx-admin-vouchers-list',
  components: {
    'adx-toggle': Toggle,
    'adx-dropdown-sort': DropdownSort,
  },
  props: {
    items: {
      required: false
    }
  },
  data() {
    return {
      isEmpty: false,
      loading: false
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    formatDate(date){
      return formatShortDate(date)
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>  